var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import './guide.scss';
import { UuiFlexlayout } from '@aonunited/react';
import { getApplicationConfig } from '../../constants/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useClientPageStore, useErrorStore } from '../../store';
import { helpDocGuid } from '../../constants/helpDocGuids';
var GuideTab = function () {
    var applicationID = getApplicationConfig().applicationId;
    var _a = useState([]), col_1 = _a[0], setCol_1 = _a[1];
    var _b = useState([]), col_2 = _b[0], setCol_2 = _b[1];
    var clientStore = useClientPageStore();
    var errorStore = useErrorStore();
    var navigation = useNavigate();
    useEffect(function () {
        if (applicationID === 1) {
            setCol_1([
                {
                    title: 'MarketPreView',
                    description: 'This is a comprehensive overview of MarketPreView. It explains key features including news and research and answers frequently asked questions.',
                    documentGuid: helpDocGuid.marketPreView
                }, {
                    title: 'Fact Sheets',
                    description: 'Summaries of key financial results, ratios and other metrics ("fact sheets") can be found attached to most of the companies listed in the Market Guide.',
                    documentGuid: helpDocGuid.factSheetGuide
                }
            ]);
            setCol_2([
                {
                    title: 'Ratings Notification Service',
                    description: 'This guide provides detailed instructions on how to subscribe to the Ratings Notification Service for individual companies. This service provides notification of rating or outlook changes from AM Best or S&P.',
                    documentGuid: helpDocGuid.ratingNotificationService
                }, {
                    title: 'Ratings and Rating Agencies',
                    description: 'This guide contains information about the ratings and outlooks that are displayed in MarketPreView. It also includes information about the associated rating agencies and contains links to the rating agency websites.',
                    documentGuid: helpDocGuid.ratingAndRatingAgencies
                }, {
                    title: 'U.S. Treasury Acceptable Sureties',
                    description: 'This guide contains links to the website of the Financial Management Service (FMS) which is the bureau of the U.S. Treasury Department responsible for the administration of the surety bond program. The links in this guide identify acceptable surety companies that are able to write or reinsure federal bonds.',
                    documentGuid: helpDocGuid.usTreasuryAcceptableSureties
                }
            ]);
        }
        else if (applicationID === 2) {
            setCol_1([
                {
                    title: 'MarketReView',
                    description: 'This is a comprehensive overview of MarketReView.  It explains key features including news and research and answers frequently asked questions.',
                    documentGuid: helpDocGuid.marketReView
                }, {
                    title: 'Market & Group Profiles',
                    description: 'This guide contains a description of all ratios and metrics used in U.S. and International Market Profile reports, Lloyds Profile reports and Group Profile reports.  The calculation for each ratio is displayed along with how these ratios and metrics may be interpreted.',
                    documentGuid: helpDocGuid.marketGroupProfile
                }, {
                    title: 'Ratings Notification Service',
                    description: 'This guide provides detailed instructions on how to subscribe to the Ratings Notification Service for individual companies.  This service provides notification of rating or outlook changes from AM Best or S&P.',
                    documentGuid: helpDocGuid.ratingNotificationService
                }, {
                    title: 'Ratings and Rating Agencies',
                    description: 'This guide contains information about the ratings and outlooks that are displayed in MarketReView.  It also includes information about the associated rating agencies and contains links to the rating agency websites.',
                    documentGuid: helpDocGuid.ratingAndRatingAgencies
                }
            ]);
            setCol_2([
                {
                    title: 'Reporting of Reinsurance Recoverables',
                    description: 'The purpose of this Guide is to help U.S. ceding insurers determine the statutory reporting classification of reinsurance recoverables from both U.S. reinsurers and non-U.S. reinsurers. This document contains explanations of key concepts, state reporting instructions, contact information and web links to the insurance department in each of the fifty states and the District of Columbia. Using this information clients should be able to determine the classification of recoverables under most circumstances',
                    documentGuid: helpDocGuid.reportingRecoverables
                }, {
                    title: 'U.S. Treasury Acceptable Sureties',
                    description: 'This guide contains links to the website of the Financial Management Service (FMS) which is the bureau of the U.S. Treasury Department responsible for the administration of the surety bond program.  The links in this guide identify acceptable surety companies that are able to write or reinsure federal bonds.',
                    documentGuid: helpDocGuid.usTreasuryAcceptableSureties
                }
            ]);
        }
        else {
            setCol_1([
                {
                    title: 'Market Guide',
                    description: 'This overview explains key features of the Market Guide, including news, research and frequently asked questions.',
                    documentGuid: helpDocGuid.marketSecurityGuide
                }, {
                    title: 'Market Security Briefs (formerly Advisories)',
                    description: 'You will find Market Security Briefs attached to the individual market listed on the Market Guide.  Click on the Home tab (above) and use the Search field to find the market.',
                    url: ''
                }, {
                    title: 'Client Notification Letters',
                    description: 'If a client wants to use companies that are not on the Market Guide, you must provide the client a Notification Letter at the time of placement to inform them that Aon’s Market Security Committee has not authorized those companies for use.  In addition, the use of a company outside of any restrictions that have been placed upon the company requires the receipt of the appropriate Notification Letter at the time of placement.',
                    url: 'https://one.aon.net/sites/intranet-aonglobal/en-us/ms/Pages/Site%20Pages/Client-Notification-Letters.aspx'
                }, {
                    title: 'Requests for Additions to the Market Guide',
                    description: 'If you are based in the Americas, use the Americas Market Guide Request Form; otherwise, use the International Market Guide Request Form.Send the completed form to the email addresses provided on the form for the appropriate market security contact as well as your business unit representative.',
                    url: 'https://one.aon.net/sites/intranet-aonglobal/en-us/ms/Pages/Site%20Pages/Market-Requests-and-RFPs.aspx'
                }
            ]);
            setCol_2([
                {
                    title: 'Intermediary and UK TOBA Information',
                    description: 'Information for intermediaries (MGAs, MGUs, wholesalers, other brokers, etc.), as well as Aon Ltds Carrier Terms of Business Agreement(TOBA) register, can be found here.',
                    url: 'https://one.aon.net/sites/intranet-aonglobal/en-us/ms/Pages/Site%20Pages/Market-Security.aspx'
                }, {
                    title: 'Fact Sheets',
                    description: 'Summaries of key financial results, ratios and other metrics ("fact sheets") can be found attached to most of the companies listed in the Market Guide.',
                    documentGuid: helpDocGuid.factSheetGuide
                }, {
                    title: 'U.S. Treasury Acceptable Sureties',
                    description: 'This guide contains links to the website of the Financial Management Service (FMS) which is the bureau of the U.S. Treasury Department responsible for the administration of the surety bond program. The links in this guide identify acceptable surety companies that are able to write or reinsure federal bonds.',
                    documentGuid: helpDocGuid.usTreasuryAcceptableSureties
                }
            ]);
        }
    }, [applicationID]);
    var OpenDocument = function (record) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!record.documentGuid) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, clientStore.handlePdfDownload(record.documentGuid)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    if (record.url != '') {
                        if (record.url.lastIndexOf(".aspx") > 0) {
                            window.open(record.url, "_blank");
                        }
                    }
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var GetIcon = function (record) {
        if (record.documentGuid) {
            return React.createElement(FontAwesomeIcon, { style: { marginLeft: "8px", fontSize: "16px", color: "red", cursor: "pointer" }, icon: faFilePdf });
        }
        else if (record.url != '') {
            if (record.url.lastIndexOf(".aspx") > 0) {
                return React.createElement("svg", { style: { marginLeft: "8px", color: "black" }, width: "8px", height: "9px", focusable: "false", viewBox: "0 0 7 8", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                        React.createElement("g", { transform: "translate(-7.000000, -10.000000)", stroke: "currentColor" },
                            React.createElement("g", { transform: "translate(7.500000, 10.500000)" },
                                React.createElement("line", { x1: "5.5", y1: "0.5", x2: "0", y2: "6.18181818" }),
                                React.createElement("polyline", { points: "6 4.24554252 6 1.16354154e-16 1.98755042 0" })))));
            }
        }
        return null;
    };
    return (React.createElement("div", { className: 'outer_wrapper' },
        React.createElement("div", null, "GUIDES"),
        React.createElement("div", { className: 'guide-container' },
            React.createElement(UuiFlexlayout, { direction: 'column', gap: "sm", style: { width: "49%" } }, col_1 === null || col_1 === void 0 ? void 0 : col_1.map(function (item, index) {
                var icon = GetIcon(item);
                return (React.createElement("div", { key: index + "_guide", onClick: function () { return OpenDocument(item); } },
                    React.createElement("div", { key: index + "_title", className: icon ? 'title' : "title no-underline" },
                        item.title,
                        React.createElement("span", null, icon)),
                    React.createElement("div", { key: index + "_desc", className: 'desc' }, item.description)));
            })),
            React.createElement("div", { style: { width: "2%" } }),
            React.createElement(UuiFlexlayout, { direction: 'column', gap: "sm", style: { width: "49%" } }, col_2 === null || col_2 === void 0 ? void 0 : col_2.map(function (item, index) {
                var icon = GetIcon(item);
                return (React.createElement("div", { key: index + "_guide", onClick: function () { return OpenDocument(item); } },
                    React.createElement("div", { key: index + "_title", className: icon ? 'title' : "title no-underline" },
                        item.title,
                        React.createElement("span", null, icon)),
                    React.createElement("div", { key: index + "_desc", className: 'desc' }, item.description)));
            })))));
};
export default GuideTab;
